import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkConnectivityService {
  private readonly _offline$ = new BehaviorSubject<boolean>(!navigator.onLine);
  readonly isOffline$ = this._offline$.asObservable();

  constructor(zone: NgZone) {
    // use NgZone so change-detection isn’t blocked
    const offline$  = fromEvent(window, 'offline').pipe(map(() => true));
    const online$   = fromEvent(window, 'online').pipe(map(() => false));

    merge(offline$, online$).subscribe(isOff =>
      zone.run(() => this._offline$.next(isOff))
    );
  }
}
